"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.page = void 0;
var classnames_1 = require("classnames");
var React = require("react");
var react_redux_1 = require("react-redux");
var redux_1 = require("redux");
var Pages_1 = require("@/rendering/common/Pages");
var Enquire_1 = require("@/pages/common/components/Enquire");
var ResourcePage_1 = require("@/pages/common/components/ResourcePage");
var actions_1 = require("@/pages/newsAndInsights/actions/actions");
var styles_1 = require("@/pages/newsAndInsights/styles");
var core_1 = require("@material-ui/core");
var ArticleListing_1 = require("@/pages/newsAndInsights/components/ArticleListing/ArticleListing");
var ArticleSearch_1 = require("@/pages/newsAndInsights/components/ArticleSearch/ArticleSearch");
var ServerSideSchema_1 = require("@/pages/common/components/schema/ServerSideSchema");
var styles_2 = require("@/pages/articleDetail/components/ArticleHeader/styles");
var mapStateToProps = function (state) { return (__assign(__assign({}, state), { menu: state.layout.menulist.filter(function (it) { return it.page === Pages_1.Pages.RESOURCES; })[0], showLanguageUnavailable: state.showLanguageUnavailable })); };
var mapDispatchToProps = function (dispatch) { return ({
    changePage: function (page) {
        return dispatch(actions_1.default.changePage(page));
    },
    setSearchText: function (value) {
        return dispatch(actions_1.default.setSearchText(value));
    },
    // tslint:disable-next-line: max-line-length
    setSearchKeywords: function (values) {
        return dispatch(actions_1.default.setSearchKeywords(values));
    },
    searchArticles: function () { return dispatch(actions_1.default.searchArticles()); },
    setLanguageUnavailable: function (isUnavailable) {
        return dispatch(actions_1.default.setLanguageUnavailable(isUnavailable));
    },
}); };
exports.page = function (props) {
    var headerSection = props.headerSection, searchSection = props.searchSection, newsArticles = props.newsArticles, changePage = props.changePage, setSearchText = props.setSearchText, setSearchKeywords = props.setSearchKeywords, searchArticles = props.searchArticles, setLanguageUnavailable = props.setLanguageUnavailable;
    // Store the initial value of showLanguageUnavailable in state
    // Use true as a fallback if undefined to ensure banner shows initially
    var _a = React.useState(props.showLanguageUnavailable !== undefined
        ? props.showLanguageUnavailable
        : true), isLanguageUnavailable = _a[0], setIsLanguageUnavailable = _a[1];
    // Update state if props change and ensure the Redux store keeps the value
    React.useEffect(function () {
        if (props.showLanguageUnavailable !== undefined) {
            setIsLanguageUnavailable(props.showLanguageUnavailable);
            // Make sure the value is persisted in Redux
            setLanguageUnavailable(props.showLanguageUnavailable);
        }
        else if (isLanguageUnavailable) {
            // If props.showLanguageUnavailable becomes undefined but our state is true,
            // update the Redux store to maintain the banner
            setLanguageUnavailable(true);
        }
    }, [props.showLanguageUnavailable, isLanguageUnavailable]);
    // Initialize Redux store on mount
    React.useEffect(function () {
        // If the initial value is undefined in Redux but we have a local state value,
        // update the Redux store
        if (props.showLanguageUnavailable === undefined && isLanguageUnavailable) {
            setLanguageUnavailable(true);
        }
    }, []);
    var pager = newsArticles.pager, t = newsArticles.translate;
    var headStyle = {
        backgroundImage: "url(/res/img/skyline_hk.jpg)",
        backgroundSize: "center 23%",
        backgroundAttachment: "unset",
    };
    var formStyle = {
        overflowX: "hidden",
    };
    var formClass = "c-ssection__block c-ssection__block--noflex l-container__mfull";
    var currentPage = Pages_1.Pages.NEWS_AND_INSIGHTS;
    var renderPagination = function (pager) {
        var onGotoPrevPage = function () {
            changePage(pager.currentPage - 1);
            setLanguageUnavailable(false);
        };
        var onGotoNextPage = function () {
            changePage(pager.currentPage + 1);
            setLanguageUnavailable(false);
        };
        var renderPrevPage = function () {
            if (pager.currentPage === 1)
                return "";
            return (React.createElement("a", { onClick: onGotoPrevPage, className: "c-pagination__item" },
                React.createElement("span", null, t.previous)));
        };
        var renderNextPage = function () {
            if (pager.currentPage === pager.totalPages)
                return "";
            return (React.createElement("a", { onClick: onGotoNextPage, className: "c-pagination__item" },
                React.createElement("span", null, t.next)));
        };
        var renderPage = function (i, current) {
            var goToPage = function (e) {
                e.preventDefault();
                changePage(i + 1);
                setLanguageUnavailable(false);
                return false;
            };
            var classes = classnames_1.default([
                "c-pagination__item",
                "c-pagination__item--number",
                {
                    "c-pagination__item--current": i === current,
                },
            ]);
            if (i === current) {
                return (React.createElement("span", { key: i, className: classes }, i + 1));
            }
            var getPagedUrl = function (n) {
                var language = props.layout.language.languages.filter(function (it) { return it.id === props.layout.language.current; })[0];
                var languageCode = language.code1;
                // tslint:disable-next-line: max-line-length
                return "/" + languageCode + "/property-news/page/" + n;
            };
            var pageUrl = getPagedUrl(i + 1);
            return (React.createElement("a", { key: i, onClick: goToPage, className: "c-pagination__item c-pagination__item--number", href: pageUrl },
                React.createElement("span", null, i + 1)));
        };
        var renderPages = function () {
            var pages = [];
            for (var i = 0; i < pager.totalPages; i = i + 1) {
                pages.push(renderPage(i, pager.currentPage - 1));
            }
            pages = pages.slice(pager.currentPage - 1, pager.currentPage + 4 >= pager.totalPages
                ? pager.totalPages - 1
                : pager.currentPage + 4);
            if (pager.currentPage > 2) {
                pages.unshift(React.createElement("span", { key: "pred", className: "c-pagination__item c-pagination__item--number" }, "..."));
            }
            if (pager.currentPage !== 1) {
                pages.unshift(renderPage(0, -1));
            }
            if (pager.currentPage < pager.totalPages - 5) {
                pages.push(React.createElement("span", { key: "postd", className: "c-pagination__item c-pagination__item--number" }, "..."));
            }
            if (pager.currentPage <= pager.totalPages) {
                pages.push(renderPage(pager.totalPages - 1, pager.currentPage - 1));
            }
            return pages;
        };
        if (pager.totalPages <= 1) {
            return null;
        }
        return (React.createElement("div", { className: "c-pagination u-text-center l-pad-around--2" },
            renderPrevPage(),
            React.createElement("div", { className: "c-pagination__items" }, renderPages()),
            renderNextPage()));
    };
    var renderLanguageUnavailableBanner = function () {
        return isLanguageUnavailable && (React.createElement(styles_2.LanguageUnavailableContainer, null,
            React.createElement(styles_2.LanguageUnavailableTitle, null, t.languageUnavailableTitle),
            React.createElement(styles_2.LanguageUnavailableMessage, null, t.languageUnavailableMessage)));
    };
    return (React.createElement(ResourcePage_1.default, { title: headerSection.translate.title, headStyle: headStyle, currentPage: currentPage, menu: props.menu },
        React.createElement("div", { className: "c-ssection c-ssection--simple" },
            React.createElement(core_1.Hidden, { xsDown: true },
                React.createElement("div", { style: { height: 20 } })),
            renderLanguageUnavailableBanner(),
            React.createElement("div", { className: formClass, style: formStyle },
                React.createElement(styles_1.Header, { className: "c-page-header", style: { marginBottom: 0 } },
                    React.createElement("div", { className: "c-page-header__body" },
                        React.createElement(styles_1.Paragraph, null, headerSection.translate.paragraph))),
                React.createElement(ArticleSearch_1.ArticleSearch, { searchSection: searchSection, setSearchText: setSearchText, setSearchKeywords: setSearchKeywords, searchArticles: searchArticles }),
                React.createElement(ArticleListing_1.ArticleListing, { newsArticles: newsArticles }),
                React.createElement("div", { style: { height: 20 } }),
                renderPagination(pager))),
        React.createElement(ServerSideSchema_1.default, null),
        React.createElement(Enquire_1.default, null)));
};
var enhance = redux_1.compose(react_redux_1.connect(mapStateToProps, mapDispatchToProps));
exports.default = enhance(exports.page);
